import React from 'react';
import { Grid } from '@nextiva/next-ui-components';
import clsx from 'clsx';

import { SvgActive } from 'components/SvgIcon';

import { DomainActions } from '../DomainActions';

const DomainRow = ({ toggleModal, toggleDrawer, domain: { name, status } }) => {
  return (
    <Grid
      container
      spacing={0}
      alignItems="center"
      className={clsx('m-table-row', {
        'm-domain-row__pending': status === 'Pending verification',
      })}
    >
      <Grid item xs={6}>
        <span className="Body">{name}</span>
      </Grid>
      <Grid item xs={6} className="m-domain-row__actions">
        <div className="m-domain-row__domain-item">
          {status === 'Authenticated' && (
            <div className="m-domain-row__svg">
              <SvgActive />
            </div>
          )}
          <div
            className={
              status === 'Authenticated'
                ? 'Caption green m-domain-row__authenticated'
                : 'Body'
            }
          >
            {status}
          </div>
        </div>
        <div className="actionBase--selector">
          <DomainActions
            status={status}
            domain={name}
            toggleModal={toggleModal}
            toggleDrawer={toggleDrawer}
          />
        </div>
      </Grid>
    </Grid>
  );
};

export default DomainRow;
